export default "__VITE_PUBLIC_ASSET__f0d950b6__"